module.exports = __webpack_public_path__ + "src/assets/img/debth-banner.3c019541.png";